module.exports = __webpack_public_path__ + "static/media/kiss-beam.0e7bf1c0.svg";